import { PaymentsSortQueryParam } from '@melio/platform-api';

import { PayDashboardSortingType } from '../../types';

export const convertFinancingTabSortToApiSort = ({
  sortDirection,
}: NonNullable<PayDashboardSortingType['sortingState']>): PaymentsSortQueryParam[] => [
  { field: 'vendor.name', order: sortDirection },
];
